import { Input } from "../../components/input";
import { BSShowService } from "@/models/showService";

export const InlineQuantityInput = ({ 
  show, 
  onChange 
}: { 
  show: BSShowService, 
  onChange: (quantity: number) => void 
}) => {
  return (
    <Input
      type="number"
      min="0"
      value={show.quantity}
      onChange={(e) => onChange(parseInt(e.target.value) || 0)}
      className="w-24"
    />
  );
};